module.exports = __webpack_public_path__ + "img/member-statistics.95209718.webp";